// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .related_recent_fact_check_container {
    width: 100%;
    height: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: column !important;
    align-items: center !important;
  }
  .related_recent_fact_check_card_container {
    width: 100% !important;
    flex-direction: column !important;
  }
  .related_fact_check_banner {
    width: 100%;
  }
  .recent_fact_check_banner {
    width: 100;
    height: 100%;
  }
  .related_fact_check_container {
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: 100%;
    gap: 20px;
    margin-bottom: 20px;
  }
  .recent_fact_check_banner {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .recent_fact_check_title_text {
    font-size: 16px !important;
    line-height: 25px !important;
  }

  .home_user_contribution_two_profile {
    font-size: 18px;
    font-family: "Lato";
  }
  .single_fact_check_report_container {
    display: none !important;
  }
  .donation_secondary_banner {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .single_fact_check_claim_content_wrapper {
    flex-direction: column;
  }
  .single_fact_check_content_container {
    width: 100%;
  }
  .single_fact_check_whats_app_container {
    display: none;
  }
  .single_fact_claim_title,
  .single_fact_check_rating_container {
    align-items: start;
    justify-content: flex-start !important;
  }
  .secondary_donation_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: 0px !important;
  }

  .recent_fact_check_title_text_ta {
    font-size: 15px !important;
    line-height: 25px !important;
  }
  .reply_comment_text {
    font-size: 13px;
  }
  .claim_wrapper {
    display: none;
  }
  .single_fact_check_spread_news_container >p> img{
    width: 90% !important;
    height: auto !important;
      }
      .single_fact_check_spread_news_container  img{
        width: 90% !important;
        height: auto !important;
          }
          .responsive-iframe-container {
            position: relative;
            width: 100%; /* Full width of the parent */
            padding-top: 160%; /* Aspect ratio (height divided by width; e.g., 800/500 = 1.6) */
            overflow: hidden;
            border: 1px solid #d2c7c7;
            border-radius: 15px;
          }
          
          .responsive-iframe-container iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%; /* Full width of the container */
            height: 100%; /* Full height of the container */
            border: none;
          }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_768_1023/screen_768__1023_single_fact_check.css"],"names":[],"mappings":"AAAA;EACE;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,iCAAiC;IACjC,8BAA8B;EAChC;EACA;IACE,sBAAsB;IACtB,iCAAiC;EACnC;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,YAAY;IACZ,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;;IAEE,kBAAkB;IAClB,sCAAsC;EACxC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,uBAAuB;MACrB;MACA;QACE,qBAAqB;QACrB,uBAAuB;UACrB;UACA;YACE,kBAAkB;YAClB,WAAW,EAAE,6BAA6B;YAC1C,iBAAiB,EAAE,gEAAgE;YACnF,gBAAgB;YAChB,yBAAyB;YACzB,mBAAmB;UACrB;;UAEA;YACE,kBAAkB;YAClB,MAAM;YACN,OAAO;YACP,WAAW,EAAE,gCAAgC;YAC7C,YAAY,EAAE,iCAAiC;YAC/C,YAAY;UACd;AACV","sourcesContent":["@media only screen and (min-width: 768px) and (max-width: 1023px) {\n  .related_recent_fact_check_container {\n    width: 100%;\n    height: 100%;\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column !important;\n    align-items: center !important;\n  }\n  .related_recent_fact_check_card_container {\n    width: 100% !important;\n    flex-direction: column !important;\n  }\n  .related_fact_check_banner {\n    width: 100%;\n  }\n  .recent_fact_check_banner {\n    width: 100;\n    height: 100%;\n  }\n  .related_fact_check_container {\n    height: 100%;\n    width: 100%;\n    display: grid;\n    grid-template-columns: 100%;\n    gap: 20px;\n    margin-bottom: 20px;\n  }\n  .recent_fact_check_banner {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n  .recent_fact_check_title_text {\n    font-size: 16px !important;\n    line-height: 25px !important;\n  }\n\n  .home_user_contribution_two_profile {\n    font-size: 18px;\n    font-family: \"Lato\";\n  }\n  .single_fact_check_report_container {\n    display: none !important;\n  }\n  .donation_secondary_banner {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  .single_fact_check_claim_content_wrapper {\n    flex-direction: column;\n  }\n  .single_fact_check_content_container {\n    width: 100%;\n  }\n  .single_fact_check_whats_app_container {\n    display: none;\n  }\n  .single_fact_claim_title,\n  .single_fact_check_rating_container {\n    align-items: start;\n    justify-content: flex-start !important;\n  }\n  .secondary_donation_container {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    border-radius: 0px !important;\n  }\n\n  .recent_fact_check_title_text_ta {\n    font-size: 15px !important;\n    line-height: 25px !important;\n  }\n  .reply_comment_text {\n    font-size: 13px;\n  }\n  .claim_wrapper {\n    display: none;\n  }\n  .single_fact_check_spread_news_container >p> img{\n    width: 90% !important;\n    height: auto !important;\n      }\n      .single_fact_check_spread_news_container  img{\n        width: 90% !important;\n        height: auto !important;\n          }\n          .responsive-iframe-container {\n            position: relative;\n            width: 100%; /* Full width of the parent */\n            padding-top: 160%; /* Aspect ratio (height divided by width; e.g., 800/500 = 1.6) */\n            overflow: hidden;\n            border: 1px solid #d2c7c7;\n            border-radius: 15px;\n          }\n          \n          .responsive-iframe-container iframe {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%; /* Full width of the container */\n            height: 100%; /* Full height of the container */\n            border: none;\n          }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
